import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const Fieldset = ui.S9Fieldset.default;
const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const BaseRequirementForm = ({ schema }: Props) => {
  const fields = [
    {
      field: 'summary',
    },
    {
      field: 'code',
      colSize: 6,
    },
    {
      field: 'question_type',
      colSize: 9,
    },
    {
      field: 'sequence',
      colSize: 3,
    },
    {
      field: 'base_requirement_id',
      colSize: 3,
    },
    {
      field: 'requirement_section_id',
      label: 'Requirement section',
    },
    {
      field: 'required_document_types',
    },
    {
      field: 'allow_text_area',
      colSize: 6,
    },
    {
      field: 'is_mandatory',
      colSize: 6,
    },
    {
      field: 'preserve_for_renewal',
      colSize: 6,
    },
    {
      field: 'is_active',
      colSize: 6,
    },
    {
      field: 'question',
    },
    {
      field: 'lang_set',
    },
  ];

  return (
    <S9PageSection title="Requirement details" size="sm">
      {schema && (
        <Fieldset
          context={{ id: undefined }}
          schema={schema}
          formFields={fields}
        />
      )}
    </S9PageSection>
  );
};

export default BaseRequirementForm;
